import { QueryObserver } from '@tanstack/query-core';
import { createComputed } from 'solid-js';
import { createStore } from 'solid-js/store';
import { parseQueryArgs } from './utils';
import { createBaseQuery } from './createBaseQuery';
export function createQuery(arg1, arg2, arg3) {
    // The parseQuery Args functions helps normalize the arguments into the correct form.
    // Whatever the parameters are, they are normalized into the correct form.
    const [parsedOptions, setParsedOptions] = createStore(parseQueryArgs(arg1, arg2, arg3));
    // Watch for changes in the options and update the parsed options.
    createComputed(() => {
        const newParsedOptions = parseQueryArgs(arg1, arg2, arg3);
        setParsedOptions(newParsedOptions);
    });
    return createBaseQuery(parsedOptions, QueryObserver);
}
